module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.ehAcessoExterno ? 'container' : 'content-wrapper',
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP'
    }
  }), _vm._v(" "), (_vm.acao !== 'novo') ? _c('div', [_c('section', {
    staticClass: "content-header",
    style: (_vm.ehAcessoExterno ? 'background: #ecf0f5; margin-top: 10px;' : '')
  }, [(_vm.ehAcessoExterno) ? _c('div', {
    staticClass: "login-logo yellow-bg",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h1', [_c('span', [(_vm.formularioCadastrado.opcoes.abrir.acao !== 'FORCA_SOMENTE_LEITURA') ? _c('span', [_vm._v("\n              " + _vm._s(_vm.acao === 'impressao' ? 'Formulário em Branco para Impressão' : (_vm.acao === 'visualizacao' ? 'Visualizando Formulário' : (_vm.ultimaTarefa.nome === 'SOLICITACAO' ? 'Preencha o formulário' : (_vm.ultimaTarefa.nome === 'REVISAO' ? 'Revise o formulário' : (_vm.ultimaTarefa.nome === 'ANALISE' ? 'Análise do formulário' : ''))))) + "\n              " + _vm._s(_vm.formularioPreenchimento.fk_processo) + "\n            ")]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), (_vm.formularioCadastrado.opcoes.abrir.acao !== 'FORCA_SOMENTE_LEITURA') ? _c('span', [(!_vm._.includes(['impressao', 'visualizacao'], _vm.acao)) ? _c('span', [(!_vm.loading.tela && _vm.acao === 'edicao' && _vm._.has(_vm.formularioPreenchimento, 'fk_formulario')) ? _c('span', [(_vm.salvaFormulario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
    staticClass: "button--moema warning",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 50px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-borda-dark) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Salvando")]) : (_vm.salvaFormulario.statusSalvamento === 'FEITO') ? _c('span', {
    staticClass: "button--moema success",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 10px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-verde) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Formulário salvo")]) : _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarPreenchimento(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [_c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "color": "success",
      "type": "button",
      "title": '<h5>' + (_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.ultimaTarefa.nome) ? 'Clique para enviar seu formulário para a Fundação BB' : 'Clique para concluir sua análise') + '</h5>',
      "aria-hidden": "true"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.validaConclusao($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), (_vm.ehSubFormulario) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.replace('/#/inicial')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Fechar")])], 1) : _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.go(-1) || _vm.$router.push('/#/inicial')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading.tela && false) ? _c('span', {
    staticClass: "indicadores-cb-inline"
  }, [_c('div', {
    staticClass: "juntos"
  }, [_c('i', {
    class: (_vm.salvaFormulario.salvamentoAutomaticoAtivo ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.salvaFormulario.salvamentoAutomaticoAtivo = !_vm.salvaFormulario.salvamentoAutomaticoAtivo
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.salvaFormulario.salvamentoAutomaticoAtivo ? 'selecionado' : ''
  }, [_vm._v(_vm._s(_vm.salvaFormulario.statusSalvamento))])])]) : _vm._e()]) : _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1), _vm._v(" "), (_vm.acao === 'impressao') ? _c('span', [_c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading.tela && _vm.acao !== 'impressao' && !_vm.ehSubFormulario && !_vm.ehAcessoExterno) ? _c('span', [_c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exportarExcel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Exportar Excel")])], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content",
    style: (_vm.ehAcessoExterno ? ' background: #ecf0f5; margin-top: 0;' : '')
  }, [(_vm._.has(_vm.ultimaTarefa, 'observacao') && !_vm._.isNull(_vm.ultimaTarefa.observacao) && !_vm.ehSubFormulario && _vm.ultimaTarefa.nome !== 'SOLICITACAO') ? _c('div', {
    staticClass: "alert alert-info alert-dismissible hidden-print"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ultimaTarefa.observacao)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [(_vm.formularioCadastrado.opcoes.abrir.acao !== 'FORCA_SOMENTE_LEITURA') ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "w100 imprimir",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', {}, [_c('div', {
    staticStyle: {
      "font-size": "35px !important",
      "font-family": "sans-serif",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.formularioCadastrado.nome))])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('span', {
    staticClass: "hidden-print"
  }, [_c('h4', [_vm._v(_vm._s(_vm.formularioCadastrado.nome))]), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "corpo_formulario"
    }
  }, _vm._l((_vm.formularioPreenchimento.formulario), function(controle, idx) {
    return (controle.mostrar) ? _c('div', {
      staticClass: "box-body"
    }, [(_vm._.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) ? _c('div', {
      ref: controle.id,
      refInFor: true,
      class: controle.obrigatorio ? 'required-field' + (_vm.errors.first(controle.id) || (_vm.errors.first(controle.id + '-INICIO') || _vm.errors.first(controle.id + '-TERMINO')) ? ' has-error' : '') : ''
    }, [_c('label', {
      staticClass: "control-label col-md-12 tituloControle"
    }, [(!_vm._.isNull(_vm.formularioCadastrado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
      staticClass: "text-gray"
    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Tílulo da questão não encontrado!!!' : controle.titulo)
      }
    }), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-question-circle hidden-print",
      attrs: {
        "title": '<h5>' + (controle.descricao) + '</h5>',
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "visible-print",
      staticStyle: {
        "font-style": "italic"
      },
      domProps: {
        "innerHTML": _vm._s(controle.descricao)
      }
    }), _vm._v(" "), (controle.elemento === 'NUMERO') ? _c('div', {
      class: _vm._.includes(['TELEFONE', 'CNPJ', 'CPF'], controle.configuracao.formato) ? 'col-md-4' : 'col-md-3'
    }, [(controle.configuracao.formato === 'CPF') ? _c('span', [_c('the-mask', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "mask": ['###.###.###-##'],
        "type": "text",
        "placeholder": "000.000.000-00",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "name": controle.id
      },
      nativeOn: {
        "blur": function($event) {
          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padStart(controle.valor, 11, '0') : null;
          _vm.validacaoElementoChave(idx);
          _vm.validaCpfCnpj(idx)
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    })], 1) : (controle.configuracao.formato === 'CNPJ') ? _c('span', [_c('the-mask', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "mask": ['##.###.###/####-##'],
        "type": "text",
        "placeholder": "00.000.000/0000-00",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "name": controle.id
      },
      nativeOn: {
        "blur": function($event) {
          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padStart(controle.valor, 14, '0') : null;
          _vm.validacaoElementoChave(idx);
          _vm.validacaoElementoChave(idx);
          _vm.validaCpfCnpj(idx)
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    })], 1) : (controle.configuracao.formato === 'TELEFONE') ? _c('span', [_c('the-mask', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "mask": ['(##) ####-####', '(##) #####-####'],
        "type": "text",
        "placeholder": "(00) 00000-0000",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "name": controle.id
      },
      nativeOn: {
        "blur": function($event) {
          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padStart(controle.valor, 11, '9') : null;
          _vm.validacaoElementoChave(idx)
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    })], 1) : (controle.configuracao.formato === 'CEP') ? _c('span', [_c('the-mask', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "mask": ['#####-###'],
        "type": "text",
        "placeholder": "00000-000",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "name": controle.id
      },
      nativeOn: {
        "blur": function($event) {
          controle.valor = !_vm._.isEmpty(controle.valor) ? _vm._.padEnd(controle.valor, 8, '0') : null;
          _vm.validacaoElementoChave(idx)
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    })], 1) : (controle.configuracao.formato === 'MOEDA') ? _c('span', [_c('money', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "name": controle.id
      },
      nativeOn: {
        "blur": function($event) {
          _vm.executarRegras();
          _vm.validacaoElementoChave(idx)
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    })], 1) : (controle.configuracao.formato === 'INTEIRO') ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "max": !_vm._.isNull(controle.configuracao.maximo) ? controle.configuracao.maximo : 999999999999,
        "min": !_vm._.isNull(controle.configuracao.minimo) ? controle.configuracao.minimo : 0,
        "name": controle.id
      },
      domProps: {
        "value": (controle.valor)
      },
      on: {
        "blur": function($event) {
          _vm.executarRegras();
          _vm.validacaoElementoChave(idx)
        },
        "keyup": function($event) {
          controle.valor = _vm._.toSafeInteger(('' + controle.valor).replace(/\D+/g, ''))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "valor", $event.target.value)
        }
      }
    })]) : (controle.configuracao.formato === 'DECIMAL') ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "max": !_vm._.isNull(controle.configuracao.maximo) ? controle.configuracao.maximo : 999999999999,
        "min": !_vm._.isNull(controle.configuracao.minimo) ? controle.configuracao.minimo : 0,
        "name": controle.id
      },
      domProps: {
        "value": (controle.valor)
      },
      on: {
        "blur": function($event) {
          _vm.executarRegras();
          _vm.validacaoElementoChave(idx)
        },
        "keyup": function($event) {
          controle.valor = _vm._.toNumber(('' + controle.valor).replace(/[^.0-9]+/g, ''))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "valor", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'duplicidade')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'duplicidade')))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'max_value')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v("Número maior que o limite de " + _vm._s(controle.configuracao.maximo))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'min_value')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v("Número menor que o limite de " + _vm._s(controle.configuracao.minimo))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'cpf_digito')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'cpf_digito')))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'cnpj_digito')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'cnpj_digito')))]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.loading.duplicidade) && controle.id === _vm.loading.duplicidade) ? _c('span', [_c('i', {
      staticClass: "etiquetaCarregando fa fa-refresh fa-spin"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_SIMPLES') ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "maxlength": _vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 250 : _vm._.toSafeInteger(controle.configuracao.maximo),
        "name": controle.id
      },
      domProps: {
        "value": (controle.valor)
      },
      on: {
        "blur": function($event) {
          _vm.executarRegras();
          _vm.validacaoElementoChave(idx)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "valor", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'duplicidade')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(" " + _vm._s(_vm.errors.firstByRule(controle.id, 'duplicidade')))]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.loading.duplicidade) && controle.id === _vm.loading.duplicidade) ? _c('span', [_c('i', {
      staticClass: "etiquetaCarregando fa fa-refresh fa-spin"
    })]) : _vm._e(), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1) ? _c('i', {
      staticStyle: {
        "float": "right",
        "color": "silver"
      }
    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_LONGO') ? _c('div', {
      staticClass: "col-md-12"
    }, [(_vm._.isNull(controle.configuracao.formato) || controle.configuracao.formato === 'SOMENTE_TEXTO') ? _c('span', [_c('textarea', {
      directives: [{
        name: "resizable",
        rawName: "v-resizable"
      }, {
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "maxlength": _vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 250 : _vm._.toSafeInteger(controle.configuracao.maximo),
        "name": controle.id
      },
      domProps: {
        "value": (controle.valor)
      },
      on: {
        "blur": function($event) {
          return _vm.executarRegras()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "valor", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1) ? _c('i', {
      staticStyle: {
        "float": "right",
        "color": "silver"
      }
    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _c('span', [_c('quill-editor', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      ref: "refQuillEditor",
      refInFor: true,
      attrs: {
        "disabled": controle.grupo === 'PERSONALIZADO',
        "options": _vm.quillOptions,
        "name": controle.id
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    })], 1), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_SIMPLES') ? _c('div', {
      staticClass: "col-md-6"
    }, [(controle.configuracao.formato === 'AUTOCOMPLETE') ? _c('span', [_c('multiselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "hidden-print",
      attrs: {
        "options": _vm._.map(controle.configuracao.conteudo.linhas, 'descricao'),
        "placeholder": "Selecione uma opção",
        "selectedLabel": "Selecionado",
        "selectLabel": "",
        "deselectLabel": "",
        "name": controle.id,
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
      },
      on: {
        "select": function($event) {
          return _vm.executarRegras()
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    })], 1) : _c('span', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "form-control hidden-print",
      attrs: {
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "name": controle.id
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(controle, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.executarRegras()
        }]
      }
    }, _vm._l((controle.configuracao.conteudo.linhas), function(item) {
      return (item.mostrar) ? _c('option', {
        domProps: {
          "value": item.valor || item.descricao
        }
      }, [_vm._v(_vm._s(item.descricao))]) : _vm._e()
    }), 0)]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.take(controle.configuracao.conteudo.linhas, 50)), function(item) {
      return (item.mostrar) ? _c('p', {
        staticClass: "col-md-12 visible-print"
      }, [_c('i', {
        staticClass: "fa fa-circle-thin"
      }), _vm._v(" " + _vm._s(item.descricao) + "\n                      ")]) : _vm._e()
    }), _vm._v(" "), (controle.configuracao.conteudo.linhas.length > 50) ? _c('p', {
      staticClass: "col-md-12 text-bold visible-print"
    }, [_vm._v("\n                        ..."), _c('br'), _vm._v("\n                        Observação: Tem " + _vm._s(controle.configuracao.conteudo.linhas.length) + " elementos nesta lista."), _c('br'), _vm._v("\n                        Informe aqui, qual resposta para localizarmos o mais próximo quando for digitado este texto no sistema\n                        "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_MULTIPLA') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('multiselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "hidden-print",
      attrs: {
        "options": _vm._.map(controle.configuracao.conteudo.linhas, 'descricao'),
        "placeholder": "Selecione uma ou mais opções",
        "selectedLabel": "Selecionado",
        "selectLabel": "",
        "deselectLabel": "",
        "close-on-select": false,
        "multiple": true,
        "name": controle.id,
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
      },
      on: {
        "select": function($event) {
          return _vm.executarRegras()
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _vm._l((controle.configuracao.conteudo.linhas), function(item) {
      return (item.mostrar) ? _c('p', {
        staticClass: "col-md-12 visible-print"
      }, [_c('i', {
        staticClass: "fa fa-square-o"
      }), _vm._v(" " + _vm._s(item.descricao) + "\n                      ")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (controle.elemento === 'BOOLEANO') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('span', [_c('label', {
      staticClass: "radio-inline new-control new-control-radio",
      staticStyle: {
        "padding-top": "7px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      attrs: {
        "type": "radio",
        "name": controle.id,
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
      },
      domProps: {
        "value": controle.configuracao.conteudo.linhas[0].descricao,
        "checked": _vm._q(controle.valor, controle.configuracao.conteudo.linhas[0].descricao)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(controle, "valor", controle.configuracao.conteudo.linhas[0].descricao)
        }, function($event) {
          return _vm.executarRegras()
        }]
      }
    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[0].descricao) + " "), _c('div', {
      staticClass: "new-control-indicator"
    })]), _vm._v(" "), _c('label', {
      staticClass: "radio-inline new-control new-control-radio",
      staticStyle: {
        "padding-top": "7px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      attrs: {
        "type": "radio",
        "name": controle.id,
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
      },
      domProps: {
        "value": controle.configuracao.conteudo.linhas[1].descricao,
        "checked": _vm._q(controle.valor, controle.configuracao.conteudo.linhas[1].descricao)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(controle, "valor", controle.configuracao.conteudo.linhas[1].descricao)
        }, function($event) {
          return _vm.executarRegras()
        }]
      }
    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[1].descricao) + " "), _c('div', {
      staticClass: "new-control-indicator"
    })])]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'DATA') ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('datepicker', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      attrs: {
        "input-class": "form-control datepicker",
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "value": controle.valor || null,
        "language": _vm.$datePickerPtBR,
        "maxlength": "20",
        "use-utc": true,
        "placeholder": "__ /__ /____",
        "format": "dd/MM/yyyy",
        "name": controle.id
      },
      on: {
        "input": function($event) {
          return _vm.valorPrimitivoElemento(idx, $event)
        }
      }
    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (controle.elemento === 'PERIODO') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(3, true), _vm._v(" "), _c('datepicker', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (('date_format:dd/MM/yyyy|before:' + controle.id + '-TERMINO, true') + (controle.obrigatorio ? '|required' : '')),
        expression: "('date_format:dd/MM/yyyy|before:' + controle.id + '-TERMINO, true') + (controle.obrigatorio ? '|required' : '')"
      }],
      ref: controle.id + '-INICIO',
      refInFor: true,
      attrs: {
        "input-class": "form-control datepicker",
        "language": _vm.$datePickerPtBR,
        "maxlength": "20",
        "use-utc": false,
        "placeholder": "__ /__ /____",
        "format": "dd/MM/yyyy",
        "value": _vm._.get(controle.valor, 'inicio', null),
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "name": controle.id + '-INICIO'
      },
      on: {
        "input": function($event) {
          return _vm.valorArrayElemento(idx, 'inicio', $event)
        }
      }
    }), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'before')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(" " + _vm._s(_vm.msgErroPreenchimento['antes']))]) : _vm._e(), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('datepicker', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (('date_format:dd/MM/yyyy|after:' + controle.id + '-INICIO, true') + (controle.obrigatorio ? '|required' : '')),
        expression: "('date_format:dd/MM/yyyy|after:' + controle.id + '-INICIO, true') + (controle.obrigatorio ? '|required' : '')"
      }],
      ref: controle.id + '-TERMINO',
      refInFor: true,
      attrs: {
        "input-class": "form-control datepicker",
        "language": _vm.$datePickerPtBR,
        "maxlength": "20",
        "use-utc": false,
        "placeholder": "__ /__ /____",
        "format": "dd/MM/yyyy",
        "value": _vm._.get(controle.valor, 'termino', null),
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "name": controle.id + '-TERMINO'
      },
      on: {
        "input": function($event) {
          return _vm.valorArrayElemento(idx, 'termino', $event)
        }
      }
    })], 1), _vm._v(" "), (_vm.errors.firstByRule(controle.id + '-INICIO', 'after') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'after')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(" " + _vm._s(_vm.msgErroPreenchimento['depois']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id + '-INICIO', 'before') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'before')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(" " + _vm._s(_vm.msgErroPreenchimento['antes']))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id + '-INICIO', 'required') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'required') || _vm.errors.firstByRule(controle.id + '-INICIO', 'date_format') || _vm.errors.firstByRule(controle.id + '-TERMINO', 'date_format')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorios']))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'UF_MUNICIPIO') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('multiselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (controle.obrigatorio ? 'required' : ''),
        expression: "controle.obrigatorio ? 'required' : ''"
      }],
      staticClass: "hidden-print",
      attrs: {
        "options": _vm.municipiosUf,
        "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao),
        "placeholder": "Nome do município",
        "label": "nomcid",
        "group-values": "municipios",
        "group-label": "uf",
        "track-by": "codrai",
        "preselect-first": false,
        "close-on-select": true,
        "selectLabel": "Selecionar",
        "deselectLabel": "Desselecionar",
        "selectedLabel": "",
        "name": controle.id
      },
      on: {
        "select": function($event) {
          return _vm.executarRegras()
        }
      },
      model: {
        value: (controle.valor),
        callback: function($$v) {
          _vm.$set(controle, "valor", $$v)
        },
        expression: "controle.valor"
      }
    }), _vm._v(" "), (_vm._.has(controle.valor, 'nomcid')) ? _c('p', {
      staticClass: "col-md-12 visible-print"
    }, [_vm._v(_vm._s(controle.valor.nomcid) + " / " + _vm._s(controle.valor.sigufs))]) : _vm._e(), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required')) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (controle.elemento === 'CLASSIFICACAO') ? _c('div', {
      staticClass: "col-md-12"
    }, [(controle.configuracao.formato === 'NUMEROS') ? _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
      return _c('span', {
        class: (_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? '' : 'elemento_classificacao') + ' classificacao_numeral fa fa-stack fa-2x ',
        on: {
          "click": function($event) {
            !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorPrimitivoElemento(idx, _vm.valorPrimitivoElemento(idx) === n ? -1 : n) : false
          }
        }
      }, [_c('i', {
        class: 'fa fa-solid fa-stack-1x ' + (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-circle' : 'fa-circle-thin text-gray')
      }), _vm._v(" "), _c('span', {
        class: 'fa fa-stack-1x ' + (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-inverse' : '')
      }, [_vm._v(_vm._s(n))])])
    }), 0) : _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
      return _c('i', {
        class: (_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? '' : 'elemento_classificacao') + ' fa fa-2x ' +
          (_vm._.isNull(controle.configuracao.formato) ||
            controle.configuracao.formato === 'ESTRELA' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-star' : 'fa-star-o text-gray') :
            (controle.configuracao.formato === 'CIRCULO' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-circle' : 'fa-circle-thin text-gray') :
              (controle.configuracao.formato === 'LIKE' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-thumbs-o-up' : 'fa-thumbs-up text-gray') :
                (controle.configuracao.formato === 'EMOJI' ? (n <= _vm._.toSafeInteger(controle.valor) ? 'fa-smile-o' : 'fa-meh-o text-gray') :
                  '')))),
        on: {
          "click": function($event) {
            !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorPrimitivoElemento(idx, _vm.valorPrimitivoElemento(idx) === n ? -1 : n) : false
          }
        }
      })
    }), 0), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required') && _vm._.isNull(controle.valor)) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (_vm._.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''),
        expression: "_.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''"
      }],
      attrs: {
        "type": "hidden",
        "name": controle.id
      },
      domProps: {
        "value": (controle.valor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "valor", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'NPS') ? _c('div', {
      staticClass: "col-md-12 control-label"
    }, [_c('table', {
      class: _vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? 'elemento_NPS_escala_inativo' : 'elemento_NPS_escala',
      attrs: {
        "border": "1"
      }
    }, [_c('tr', _vm._l((_vm._.range(1, _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
      return _c('td', {
        class: 'text-center ' + (n === _vm._.toSafeInteger(controle.valor) ? 'bg-black' : ''),
        on: {
          "click": function($event) {
            !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorPrimitivoElemento(idx, n) : false
          }
        }
      }, [_vm._v(" " + _vm._s(n) + " ")])
    }), 0)]), _vm._v(" "), _c('table', {
      staticClass: "elemento_NPS_limites"
    }, [_c('tr', [_c('td', {
      staticClass: "truncar"
    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[0].descricao))]), _c('td', {
      staticClass: "text-right truncar"
    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[1].descricao))])])]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required') && _vm._.isNull(controle.valor)) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (_vm._.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''),
        expression: "_.isNull(controle.valor) && controle.obrigatorio ? 'required' : ''"
      }],
      attrs: {
        "type": "hidden",
        "name": controle.id
      },
      domProps: {
        "value": (controle.valor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "valor", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LIKERT') ? _c('div', {
      staticClass: "col-md-12 control-label"
    }, [_c('table', {
      staticClass: "elemento_likert_matrix table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "w30"
    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna) {
      return (coluna.mostrar) ? _c('th', {
        staticClass: "elemento_likert_cabecalho_coluna"
      }, [_vm._v(_vm._s(coluna.descricao))]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('tbody', _vm._l((controle.configuracao.conteudo.linhas), function(linha, idxLinha) {
      return _c('tr', [_c('td', {
        staticClass: "elemento_likert_pergunta"
      }, [_vm._v(_vm._s(_vm._.isEmpty(linha.descricao) ? 'Informe uma questão ...' : linha.descricao))]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna, idxColuna) {
        return (coluna.mostrar) ? _c('td', {
          staticClass: "elemento_likert_opcoes"
        }, [_c('i', {
          class: 'fa fa-2x ' + (_vm.valorArrayElemento(idx, linha.descricao) === coluna.descricao ? 'fa-circle' : 'fa-circle-thin'),
          on: {
            "click": function($event) {
              !_vm._.includes(['visualizacao', 'impressao'], _vm.acao) ? _vm.valorArrayElemento(idx, linha.descricao, coluna.descricao) : false
            }
          }
        })]) : _vm._e()
      })], 2)
    }), 0)]), _vm._v(" "), (_vm.errors.firstByRule(controle.id, 'required') && _vm._.isNull(controle.valor)) ? _c('span', {
      staticClass: "label label-danger hidden-print"
    }, [_vm._v(_vm._s(_vm.msgErroPreenchimento['obrigatorio']))]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.valor),
        expression: "controle.valor"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ((_vm._.isNull(controle.valor) || controle.configuracao.conteudo.linhas.length > (_vm._.keys(controle.valor)).length) && controle.obrigatorio ? 'required' : ''),
        expression: "(_.isNull(controle.valor) || controle.configuracao.conteudo.linhas.length > (_.keys(controle.valor)).length) && controle.obrigatorio ? 'required' : ''"
      }],
      attrs: {
        "type": "hidden",
        "name": controle.id
      },
      domProps: {
        "value": (controle.valor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "valor", $event.target.value)
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['LAYOUT'], controle.grupo)) ? _c('div', [(controle.elemento === 'TEXTO_FIXO') ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(controle.titulo)
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LINHA_HORIZONTAL') ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('hr')]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LOGOMARCA_FBB') ? _c('div', {
      staticClass: "col-md-12"
    }, [(!_vm._.isEmpty(controle.descricao)) ? _c('div', [_c('a', {
      attrs: {
        "href": controle.descricao
      }
    }, [_c('img', {
      attrs: {
        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
        "alt": controle.titulo
      }
    })])]) : _c('div', [_c('img', {
      attrs: {
        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
        "alt": controle.titulo
      }
    })])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SECAO') ? _c('div', {
      class: ('secao_' + (_vm._.isEmpty(controle.configuracao) ? 'padrao' : _vm._.toLower(controle.configuracao.formato))) + ' col-md-12',
      style: (!_vm._.isNull(_vm.editandoFormulario) ? 'color: black !important' : '')
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(controle.titulo)
      }
    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-question-circle hidden-print",
      attrs: {
        "title": '<h5>' + (controle.descricao) + '</h5>',
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('span', {
      staticClass: "visible-print"
    }, [_c('span', {
      staticStyle: {
        "font-size": "small !important",
        "font-style": "italic"
      }
    }, [_vm._v(_vm._s(controle.descricao))])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.grupo === 'FORMULARIO' && !_vm._.isNull(controle.configuracao.conteudo)) ? _c('div', {
      staticClass: "hidden-print"
    }, [_c('label', {
      staticClass: "control-label col-md-12 tituloControle"
    }, [(!_vm._.isNull(_vm.formularioCadastrado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
      staticClass: "text-gray"
    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Tílulo não encontrado!!!' : controle.titulo)
      }
    }), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-question-circle hidden-print",
      attrs: {
        "title": '<h5>' + (controle.descricao) + '</h5>',
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "visible-print",
      staticStyle: {
        "font-style": "italic"
      },
      domProps: {
        "innerHTML": _vm._s(controle.descricao)
      }
    }), _vm._v(" "), (_vm._.includes(['edicao', 'visualizacao'], _vm.acao)) ? _c('span', [(!_vm._.includes(['SOMENTE_LINK'], controle.configuracao.formato)) ? _c('span', [(_vm._.includes(['COMPLETO_COM_LINK', 'COMPLETO_SEM_LINK'], controle.configuracao.formato) && !_vm.loading.link) ? _c('div', {
      staticClass: "col-md-3"
    }, [(!_vm._.includes(['visualizacao', 'impressao'], _vm.acao)) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.abreFormulario(controle.configuracao.padrao[0])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Adicionar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.carregaDadosSubForm(idx, controle.configuracao.padrao[0])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.configuracao.conteudo.filter),
        expression: "controle.configuracao.conteudo.filter"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Pesquisa..."
      },
      domProps: {
        "value": (controle.configuracao.conteudo.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle.configuracao.conteudo, "filter", $event.target.value)
        }
      }
    }), _vm._v(" "), (!_vm._.isNull(controle.configuracao.conteudo.filter) && controle.configuracao.conteudo.filter.length > 0) ? _c('span', {
      staticClass: "info_discreto"
    }, [_vm._v(_vm._s(controle.configuracao.conteudo.totalRows) + " localizado(s)")]) : _vm._e()]), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COM_LINK')) ? _c('div', {
      staticClass: "col-md-5"
    }, [(!_vm._.includes(['visualizacao', 'impressao'], _vm.acao)) ? _c('span', [(_vm.loading.link) ? _c('span', {
      staticClass: "etiquetaCarregando"
    }, [_c('i', {
      staticClass: "fa fa-refresh fa-spin"
    }), _vm._v(" Gerando link ...")]) : _c('span', [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          placement: 'top',
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
      }],
      staticClass: "link_acesso",
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
      },
      on: {
        "click": function($event) {
          return _vm.copiaUrlSubFormulario(controle)
        }
      }
    }, [_c('div', {
      staticClass: "truncar"
    }, [_vm._v(_vm._s(controle.configuracao.padrao[0]))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-clone"
    }), _vm._v(" "), (_vm._.has(controle.configuracao, 'link_copia')) ? _c('span', {
      class: _vm._.get(controle.configuracao, 'link_copia.classe')
    }, [_vm._v(_vm._s(_vm._.get(controle.configuracao, 'link_copia.msg')))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "small",
        "color": "var(--cor-alerta-dark)"
      }
    }, [_vm._v(_vm._s(controle.informacao))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {}, [_c('b-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('b-table', {
      ref: controle.id + '(' + _vm.numeroAtualizacao + ')',
      refInFor: true,
      attrs: {
        "show-empty": "",
        "stacked": "md",
        "striped": "",
        "bordered": controle.configuracao.conteudo.bordered,
        "items": controle.valor,
        "fields": controle.configuracao.conteudo.colunas,
        "current-page": controle.configuracao.conteudo.currentPage,
        "per-page": controle.configuracao.conteudo.perPage,
        "filter": controle.configuracao.conteudo.filter,
        "filter-function": _vm.filtroPorItem,
        "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
        "empty-text": "Nenhum registro encontrado",
        "sort-by": controle.configuracao.conteudo.sortBy,
        "sort-desc": controle.configuracao.conteudo.sortDesc
      },
      on: {
        "filtered": _vm.onFiltered,
        "update:sortBy": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
        },
        "update:sort-by": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
        },
        "update:sortDesc": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
        },
        "update:sort-desc": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
        }
      },
      scopedSlots: _vm._u([(!_vm._.includes(controle.configuracao.formato, 'MINIMO')) ? {
        key: "actions",
        fn: function(row) {
          return [(_vm._.get(row.item, '_rowVariant', '') === 'form-salvando') ? _c('span', [_vm._v("Salvando...")]) : (_vm._.get(row.item, '_rowVariant', '') === 'form-fechando') ? _c('span', [_vm._v("Fechando...")]) : (!_vm._.includes(['visualizacao', 'impressao'], _vm.acao)) ? _c('span', [(!_vm._.get(row.item, '_rowVariant')) ? _c('span', [(_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
            attrs: {
              "color": "primary",
              "size": "button--size-ss"
            },
            nativeOn: {
              "click": function($event) {
                return _vm.abreFormulario(row.item.editar)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-pencil-square-o",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" Editar")]) : _vm._e()], 1) : _c('span', [_vm._v("Em uso agora!")]), _vm._v(" "), _c('g-button-ujarak', {
            attrs: {
              "color": "success",
              "size": "button--size-ss"
            },
            nativeOn: {
              "click": function($event) {
                return _vm.abreFormulario(row.item.visualizar)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-search",
            attrs: {
              "aria-label": "false"
            }
          }), _vm._v(" Visualizar")]), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
            attrs: {
              "color": "error",
              "size": "button--size-ss"
            },
            nativeOn: {
              "click": function($event) {
                return _vm.excluirItemSubFormulario(idx, controle.configuracao.padrao[0], row.item.excluir)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" Excluir")]) : _vm._e(), _vm._v(" "), _c('span', {
            staticStyle: {
              "font-size": "small",
              "color": "steelblue"
            }
          }, [_vm._v(_vm._s(_vm._.get(row.item, 'andamento', '')))])], 1) : _c('span', [_vm._v(" ")])]
        }
      } : null], null, true)
    }), _vm._v(" "), _c('b-row', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('b-col', {
      staticClass: "my-1",
      staticStyle: {
        "margin-top": "0"
      },
      attrs: {
        "md": "6",
        "right": ""
      }
    }, [(!_vm._.isNull(controle.valor) && controle.valor.length > 0 && controle.configuracao.conteudo.totalRows > controle.configuracao.conteudo.perPage) ? _c('span', [_c('b-pagination', {
      staticClass: "my-3",
      attrs: {
        "total-rows": controle.configuracao.conteudo.totalRows,
        "per-page": controle.configuracao.conteudo.perPage
      },
      model: {
        value: (controle.configuracao.conteudo.currentPage),
        callback: function($$v) {
          _vm.$set(controle.configuracao.conteudo, "currentPage", $$v)
        },
        expression: "controle.configuracao.conteudo.currentPage"
      }
    })], 1) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('b-col', {
      staticClass: "text-right",
      attrs: {
        "md": "6",
        "right": ""
      }
    }, [_vm._v("\n                                Total de "), _c('strong', [_vm._v(_vm._s(controle.valor.length))]), _vm._v(" registro(s)\n                              ")])], 1)], 1)], 1)]) : _c('span', [_c('div', {
      staticClass: "col-md-12"
    }, [(_vm.loading.link) ? _c('span', {
      staticClass: "etiquetaCarregando"
    }, [_c('i', {
      staticClass: "fa fa-refresh fa-spin"
    }), _vm._v(" Gerando link ...")]) : _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.carregaDadosSubForm(idx, controle.configuracao.padrao[0])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                            Link de acesso para este formulário. Repasse para quem for preencher ele: "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          placement: 'top',
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
      }],
      staticClass: "link_acesso",
      attrs: {
        "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
      },
      on: {
        "click": function($event) {
          return _vm.copiaUrlSubFormulario(controle)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(controle.configuracao.padrao[0]) + "\n                              "), _c('i', {
      staticClass: "fa fa-clone"
    }), _vm._v(" "), (_vm._.has(controle.configuracao, 'link_copia')) ? _c('span', {
      class: _vm._.get(controle.configuracao, 'link_copia.classe')
    }, [_vm._v(_vm._s(_vm._.get(controle.configuracao, 'link_copia.msg')))]) : _vm._e()])], 1)])])]) : _c('span', {
      staticClass: "col-md-12"
    }, [_vm._v("\n                      Total de "), _c('strong', [_vm._v(_vm._s(controle.valor.length))]), _vm._v(" formulários preenchidos\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((2), function(n) {
      return (controle.mostrar) ? _c('br', {
        staticClass: "visible-print"
      }) : _vm._e()
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])]), _vm._v(" "), (!_vm._.isNull(_vm.processo) && _vm._.has(_vm.processo, 'tarefas') && _vm.processo.tarefas.length > 1 && (_vm.formularioCadastrado.opcoes.historico === 'TODOS' || (!_vm.ehAcessoExterno && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.formularioCadastrado.opcoes.historico === 'SOMENTE_FBB'))) ? _c('div', {
    staticClass: "row hidden-print"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border secaoRetratil",
    on: {
      "click": function($event) {
        _vm.mostrarHistorico = !_vm.mostrarHistorico
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrarHistorico ? 'up' : 'down')
  })])]), _vm._v(" "), (_vm.mostrarHistorico) ? _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 table-responsive"
  }, [_c('div', {}, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm._.filter(_vm.processo.tarefas, ['tipo', 'USUARIO'])), function(tarefa) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(_vm._f("moment")(tarefa.inicio, 'DD/MM/YYYY hh:mm')))]), _vm._v(" "), _c('td', [(_vm._.isNull(tarefa.termino)) ? _c('span', [_vm._v("Pendente")]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.termino, 'DD/MM/YYYY hh:mm')))])]), _c('td', [_vm._v(_vm._s(_vm.nomesTarefas[tarefa.nome]))]), _vm._v(" "), _c('td', [(_vm._.isNull(tarefa.termino)) ? _c('span', [_vm._v(" ")]) : _c('span', [_vm._v(_vm._s(tarefa.observacao))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tarefa.usuario.ds_nome_usuario))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.processo.situacao === 'EM_EXECUCAO') ? _c('span', [_vm._v("\n                        Processo "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "var(--cor-destaque)"
    }
  }, [_vm._v("Em Execução")]), _vm._v(" desde "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.processo.inicio, 'DD/MM/YYYY hh:mm')))])]) : _vm._e(), _vm._v(" "), (_vm.processo.situacao === 'FEITO') ? _c('span', [_vm._v("\n                        Processo foi "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "var(--cor-sucesso)"
    }
  }, [_vm._v("Concluído")]), _vm._v(" em "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.processo.termino, 'DD/MM/YYYY hh:mm')))])]) : _vm._e(), _vm._v(" "), (_vm.processo.situacao === 'CANCELADO') ? _c('span', [_vm._v("\n                        Processo foi "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "var(--cor-atencao)"
    }
  }, [_vm._v("Cancelado")]), _vm._v(" em "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.processo.termino, 'DD/MM/YYYY hh:mm')))])]) : _vm._e()])])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm._.includes(['SOLICITACAO', 'REVISAO'], _vm.ultimaTarefa.nome) && !_vm.ehAcessoExterno && !_vm.ehSubFormulario && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "row hidden-print"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    ref: "decisão",
    staticClass: "form-group required col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "CONCLUSAO",
      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "CONCLUSAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "CONCLUSAO")
      }
    }
  }), _vm._v(" Aprovar formulário\n                            "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "REVISAO",
      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "REVISAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "REVISAO")
      }
    }
  }), _vm._v(" Encaminhar para revisão\n                            "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('decisão')) ? _c('div', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('decisão')))]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.formularioCadastrado.opcoes.observacao)) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm._.includes(['CONCLUSAO', 'REVISAO'], _vm.aprovacao.resultadoAprovacao)) ? _c('div', {
    class: (_vm.aprovacao.resultadoAprovacao === 'REVISAO' ? 'required-field' : '') + ' col-md-12 ' + (_vm.errors.first('observacao') ? 'has-error' : '')
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.aprovacao.resultadoAprovacao === 'REVISAO' ? 'Motivo para revisão' : 'Observação') + ":\n                            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.observacao),
      expression: "aprovacao.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.aprovacao.resultadoAprovacao === 'REVISAO' ? 'required' : ''),
      expression: "aprovacao.resultadoAprovacao === 'REVISAO' ? 'required' : ''"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao",
      "rows": "3",
      "id": "observacao",
      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
    },
    domProps: {
      "value": (_vm.aprovacao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aprovacao, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('observacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('observacao')))]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.formularioCadastrado.opcoes.observacao === 'TODOS' && !_vm.ehSubFormulario && ((!_vm.ehAcessoExterno && _vm.usuarioLogado.userType !== 'FUNDACAO') || _vm.ehAcessoExterno)) ? _c('div', {
    staticClass: "row hidden-print"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Opcionalmente pode adicionar informação sobre este formulário")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.observacao),
      expression: "aprovacao.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "disabled": _vm._.includes(['visualizacao', 'impressao'], _vm.acao)
    },
    domProps: {
      "value": (_vm.aprovacao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aprovacao, "observacao", $event.target.value)
      }
    }
  })])])])])])]) : _vm._e()])]) : (!_vm.loading.tela) ? _c('div', [_c('section', {
    staticClass: "content-header",
    style: (_vm.ehAcessoExterno ? 'background: #ecf0f5; margin-top: 10px;' : '')
  }, [(_vm.ehAcessoExterno) ? _c('div', {
    staticClass: "login-logo yellow-bg",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.formularioCadastrado.nome))])]), _vm._v(" "), _c('section', {
    staticClass: "content",
    style: (_vm.ehAcessoExterno ? ' background: #ecf0f5; margin-top: 0;' : '')
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gerarNovoFormularioPreenchimento($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sim")]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "error",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.replace('/#/inicial')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Não")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "w30"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-vertical.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('span', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("De")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('span', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("Até")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Histórico")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center text-bold"
  }, [_c('td', {
    staticClass: "w15"
  }, [_vm._v("Enviado em")]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_vm._v("Concluído em")]), _vm._v(" "), _c('td', {
    staticClass: "w10"
  }, [_vm._v("Fase")]), _vm._v(" "), _c('td', {
    staticClass: "w40"
  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
    staticClass: "w20"
  }, [_vm._v("Usuário Responsável")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Decisão")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Observação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_vm._v("\n                    Esta abrindo um formulário novo. "), _c('br'), _vm._v("\n                    Se continuar, então abrirá um novo link para que possa preencher, salvar e enviar o formulário para FBB.\n                    "), _c('br'), _c('br'), _vm._v("\n                    Deseja continuar?\n                    "), _c('br'), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-213a68e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/avaliacao/PreencheFormulario.vue
// module id = 1830
// module chunks = 2